






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class ProjectView extends Vue {
  public items: Common.Project[] = new Array(0);
  public params: Common.ProjectQuery = new Common.ProjectQuery();
  public importQuery = new Common.ImportQuery('プロジェクト', 'Project');
  public exportQuery = new Common.ExportQuery('プロジェクト', this.params);

  public sortOptions: any = [
    { value: 'Key', text: 'プロジェクトキー' },
    { value: 'Name', text: 'プロジェクト名' },
  ];
}
